import { useWorkspaceId } from "../../workspace/useWorkspaceId";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import {
    BASE_API_URL,
    HttpError,
} from "../utils/useGovernmentAgencyHubAppQueryClient";
import { useHttpGovernmentAgencyHubAppHeaders } from "../utils/useHttpGovernmentAgencyHubAppHeaders";
import type { DelegatedDTO } from "./DelegatedDTO";

interface UseGetDelegatedProps {
    intermediaryTaxId: string;
}

export function useGetDelegatedMutation() {
    const workspaceId = useWorkspaceId();
    const headers = useHttpGovernmentAgencyHubAppHeaders();
    const { t } = useTranslation();

    const mutation = useMutation<DelegatedDTO[], void, UseGetDelegatedProps>({
        mutationFn: async (input: UseGetDelegatedProps) => {
            const response = await fetch(
                `${BASE_API_URL}/tenants/${workspaceId}/intermediaries/${input.intermediaryTaxId}/delegated`,
                {
                    headers,
                },
            );

            if (!response.ok) {
                throw new HttpError(response);
            }

            return response.json();
        },
        meta: {
            resourceName: t("errors.resourceName.delegated"),
        },
    });

    return mutation;
}
